// extracted by mini-css-extract-plugin
export default {"container":"side_bar_tag_container__meFAj","button":"side_bar_tag_button__PNo1E"};